import './app-download.scss';
import AjaxLoad from '../ajax-load/ajax-load';

class AppDownload {
    constructor (element, options) {
        const settings = {
            loader: null,
            onSubmitted: null,
            content: document.querySelector('[data-content="download-modal"]'),
            successMessage: '[data-appdownload="again"]',
            successReloadButton: '[data-appdownload="again-button"]'
        };

        this.$appDownload = element;
        this.settings = Object.assign({}, settings, options);
    }

    initialize () {
        this.setEvents();
    }

    setEvents () {
        this.$appDownload.addEventListener('submit', (e) => {
            e.preventDefault();
            this.submitForm();
        });
    }

    submitForm () {
        const $form = this.$appDownload.querySelector('form');
        const formData = new FormData($form);

        if (this.settings.loader !== null) {
            const $loader = document.createElement('span');
            $loader.innerHTML = this.settings.loader;
            $form.appendChild($loader);
        }

        new AjaxLoad($form.action, {  
            requestMethod: $form.method,
            requestData: formData,
            onSuccess: (resultText) => {
                const $result = document.createElement('div');
                $result.innerHTML = resultText;
                this.settings.content.innerHTML = '';

                if ($result) {
                    this.settings.content.appendChild($result);
                }

                if (this.$appDownload.querySelectorAll(this.settings.successMessage).length === 1) {
                    this.initSuccess();
                }

                if (typeof this.settings.onSubmitted === 'function') {
                    if (typeof window.grecaptcha !== 'undefined') {
                        const $container = document.getElementsByClassName('g-recaptcha')[0];
                        if ($container) {
                            const siteKey = $container.getAttribute('data-sitekey');
                            if (siteKey) {
                                window.grecaptcha.ready(() => {
                                    window.grecaptcha.render($container, {
                                        sitekey: siteKey,
                                        size: 'visble'
                                    });
                                });
                            }
                        }
                    }

                    this.settings.onSubmitted(this.$appDownload);
                }
            }
        });
    }

    initSuccess () {
        const $form = this.$appDownload.querySelector('form');
        const $successMessage = this.$appDownload.querySelector(this.settings.successMessage);
        const $successReloadButton = $successMessage.querySelector(this.settings.successReloadButton);

        $successReloadButton.addEventListener('click', (e) => {
            e.preventDefault();
            $successMessage.remove();
            $form.classList.remove('is--hidden');
        });
    }
}

export { AppDownload };

window.addEventListener('content.loaded', (e) => {
    const eventDetails = e.detail;
    const $context = eventDetails.$context;

    if ($context) {
        const $appDownloads = $context.querySelectorAll('[data-appdownload]');
        if ($appDownloads.length > 0) {
            for (let i = 0; i < $appDownloads.length; i++) {
                const $download = new AppDownload($appDownloads[i], {
                    loader: window.OPTIONS.loader,
                    onSubmitted: ($result) => {
                        window.initContent($result);
                    }
                });

                $download.initialize();
            }
        }
    }
});
